export default "__VITE_ASSET__CH2_DDSp__"